import SEO from '../components/SEO/SEO';
import Titles from './../components/Titles/Titles';
import FAQs from './../components/FAQsSection/FAQs';
import LatestArticles from '../components/LatestArticles/LatestArticles';
import Make from './../components/MakeSection/Make';
import { usePageSEO } from '../hooks/usePageSEO';

const Faqs = () => {
  const seo = usePageSEO('faqs');

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <Titles page="faqPage" />
      <FAQs page='faqPage' />
      <LatestArticles />
      <Make pageKey='FaqsPage' />
    </>
  );
};

export default Faqs;